var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-speed-dial',{attrs:{"id":"mover-topo","fixed":"","bottom":"","right":"","direction":"bottom"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-btn',{attrs:{"color":"primary darken-1","dark":"","fab":""},on:{"click":_vm.rolarTopo}},[_c('v-icon',[_vm._v(" mdi-chevron-up ")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }